import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Constants from "src/helper/Constants";

let c = System.getParams();

class Order {
    static ORDER_LISTING = System.getCartUrl() + '/api/order/apac/orderHistoryList';
    static HEADER_ORDER_DETAIL = System.getOrderUrl() + '/api/order/headerDetails';
    static ORDER_EMAIL = System.getOrderUrl() + '/api/order/emailOrder';
    static ORDER_EMAIL_SALES_REPRESENTATIVE = System.getOrderUrl() + '/api/order/emailSalesRepresentative';
    static ORDER_BY_LINE_ITEM = System.getOrderUrl() + '/api/order/orderLinesByItems';
    static ORDER_BY_DELIVERY = System.getOrderUrl() + '/api/order/orderLinesByShipments';
    static PLACE_YOUR_ORDER = System.getCartUrl() + '/api/order/apac/placeOrder';
    static PLACE_ORDER_ITEMS = System.getCartUrl() + '/api/order/apac/getInternalOrderDetails';
    static ORDER_DOWNLOAD_INVOICE = System.getCartUrl() + '/invoice/apac/download';
    static EXPORT_ORDER = System.getCartUrl() + '/api/order/apac/exportThisOrder';
    static EXPORT_EMAIL = System.getCartUrl() + '/api/order/apac/exportEmail';
    static EXPORT_ORDER_ATTACHMENT = System.getOrderUrl() + '/api/order/exportOrderEmail';
    static ORDER_MANUFACTURE_LIST = System.getCartUrl() + '/api/order/apac/manfacturers';
    static ORDER_LINE_ITEM_WISE_EMAIL = System.getOrderUrl() + '/api/order/lineItemwiseEmail';
    static ORDER_PO_LINE_ITEM_EMAIL = System.getOrderUrl() + '/api/order/sendOrderPOItemEmail';
    static ORDER_DETAIL = System.getCartUrl() + '/api/order/apac/orderHistoryOrderDetails';
    static ORDER_EMAIL_SALES = System.getCartUrl() + '/api/order/apac/sendOrderDetailsEmailToSales';
    static ORDER_ITEM_EMAIL = System.getCartUrl() + '/api/order/apac/sendOrderItemEmailToSR';
    static ORDER_CANCELLATION_EMAIL = System.getCartUrl() + '/api/order/amer/orderCancellationEmail';
    static ORDER_EMAIL_INVOICE = System.getCartUrl() + '/invoice/apac/email';
    static EXECUTE_ORDER = System.getCartUrl() + '/api/order/apac/executeOrder';
    static PRODUCT_SPECIFIC_DETAILS = System.getApplicationUrl() + '/api/application/apac/getAllProductsSpecificDetails';
    static ORDER_SERVICE_REP_EMAIL = System.getCartUrl() + '/api/order/apac/apacOrderHistoryServiceRepEmail';

    static getOrderRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/orders';
    }

    static getOrderDetailRouteURL(extra_c = {}) {
        c['page'] = Constants.OrderPages.OrderDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getOrderDetailRouteFromOrderSuccessURL(extra_c = {}) {
        let p = {}
        p['page'] = Constants.OrderPages.OrderDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...p,
            ...extra_c
        });
    }

    static getOrderDetailTabsListRouteURL(extra_c = {}) {
        c['tab'] = Constants.OrderDetailTabList.BY_SHIPMENT.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/my-avnet/orders?' + $.param(c);
    }
}

export default Order;